const constants = Object.freeze({
  SUPERADMIN: "superadmin",
  ADMIN: "admin",
  RESOURCE_MANAGER: "resource_manager",
  PROGRAM_MANAGER: "program_manager",
  DATABASE_MANAGER: "database_manager",
  PRESALES_MANAGER: "presales_manager",
  AGENT: "agent",
  ALL: [
    "superadmin",
    "admin",
    "resource_manager",
    "presales_manager",
    "program_manager",
    "database_manager",
    "agent",
  ],
  PROGRAM_TYPE_ALL: [
    "Academic Program",
    "Association Program",
    "Audience Generation",
    "Channel Program",
    "Lead Generation",
    "Profiling Activity",
    "Redemption",
    "Reward",
    "Virtual Event",
  ],
  // CALL_REMARK_OPTIONS: [
  //   { value: "Call Back", label: "Call Back" },
  //   { value: "Call Disconnected", label: "Call Disconnected" },
  //   { value: "Company Closed", label: "Company Closed" },
  //   { value: "Company is acquired", label: "Company is acquired" },
  //   { value: "DND", label: "DND" },
  //   { value: "Duplicate Contact", label: "Duplicate Contact" },
  //   { value: "Helpdesk Number", label: "Helpdesk Number" },
  //   { value: "Interested", label: "Interested" },
  //   { value: "Need To Confirm", label: "Need To Confirm" },
  //   { value: "No Number", label: "No Number" },
  //   {
  //     value: "No Number Found (WebSearch)",
  //     label: "No Number Found (WebSearch)",
  //   },
  //   { value: "No Response", label: "No Response" },
  //   {
  //     value: "Not Based In Event Location",
  //     label: "Not Based In Event Location",
  //   },
  //   {
  //     value: "Not Disclosing Official Email ID",
  //     label: "Not Disclosing Official Email ID",
  //   },
  //   { value: "Not Interested", label: "Not Interested" },
  //   { value: "Not Reachable", label: "Not Reachable" },
  //   { value: "Not Relevant", label: "Not Relevant" },
  //   { value: "Out Of Order", label: "Out Of Order" },
  //   { value: "Quit The Company", label: "Quit The Company" },
  //   {
  //     value: "Receptionist Denied To Connect Call",
  //     label: "Receptionist Denied To Connect Call",
  //   },
  //   { value: "Send Mail", label: "Send Mail" },
  //   { value: "SMS Confirmation", label: "SMS Confirmation" },
  //   { value: "Switched Off", label: "Switched Off" },
  //   { value: "Tentative", label: "Tentative" },
  //   { value: "Website Not Found", label: "Website Not Found" },
  //   { value: "Will Register", label: "Will Register" },
  //   { value: "Wrong Number", label: "Wrong Number" },
  // ],
  CALL_REMARK_OPTIONS: [
    { value: "Registered", label: "Registered" },
    { value: "Already_Registered", label: "Already Registered" },
    { value: "Yet_to_Call", label: "Yet to Call" },
    { value: "Call_Back", label: "Call Back" },
    { value: "Call_Disconnected", label: "Call Disconnected" },
    { value: "Company_Closed", label: "Company Closed" },
    { value: "Company_is_acquired", label: "Company is acquired" },
    { value: "DND", label: "DND" },
    { value: "Duplicate_Contact", label: "Duplicate Contact" },
    { value: "Helpdesk_Number", label: "Helpdesk Number" },
    { value: "Interested", label: "Interested" },
    { value: "Need_To_Confirm", label: "Need To Confirm" },
    { value: "No_Number", label: "No Number" },
    {
      value: "No_Number_Found_WebSearch",
      label: "No Number Found (WebSearch)",
    },
    { value: "No_Response", label: "No Response" },
    {
      value: "Not_Based_In_Event_Location",
      label: "Not Based In Event Location",
    },
    {
      value: "Not_Disclosing_Official_Email_ID",
      label: "Not Disclosing Official Email ID",
    },
    { value: "Not_Interested", label: "Not Interested" },
    { value: "Not_Reachable", label: "Not Reachable" },
    { value: "Not_Relevant", label: "Not Relevant" },
    { value: "Out_Of_Order", label: "Out Of Order" },
    { value: "Quit_The_Company", label: "Quit The Company" },
    {
      value: "Receptionist_Denied_To_Connect_Call",
      label: "Receptionist Denied To Connect Call",
    },
    { value: "Send_Mail", label: "Send Mail" },
    { value: "SMS_Confirmation", label: "SMS Confirmation" },
    { value: "Switched_Off", label: "Switched Off" },
    { value: "Tentative", label: "Tentative" },
    { value: "Website_Not_Found", label: "Website Not Found" },
    { value: "Will_Register", label: "Will Register" },
    { value: "Wrong_Number", label: "Wrong Number" },
  ],
  //registered remarks
  REGISTERED_REMARKS: ["Registered", "Already Registered"],
  TURNOVER_RANGE: [
    "1 to 10 Crs",
    "10 to 100 Crs",
    "101 to 250 Crs",
    "251 to 500 Crs",
    "501 to 1000 Crs",
    "1001 to 2500 Crs",
    "2501 to 5000 Crs",
    "5001+ Crs",
  ],
  EMPLOYEES_RANGE: [
    "01 to 50",
    "51 to 100",
    "101 to 250",
    "251 to 500",
    "501 to 1000",
    "1001 to 2500",
    "2501 to 5000",
    "5001 to 10000",
    "10001+",
  ],
  PROGRAM_TYPE_OPTIONS: [
    { value: "Academic_Program", label: "Academic Program" },
    { value: "Association_Program", label: "Association Program" },
    { value: "Audience_Generation", label: "Audience Generation" },
    { value: "Channel_Program", label: "Channel Program" },
    { value: "Lead_Generation", label: "Lead Generation" },
    { value: "Profiling_Activity", label: "Profiling Activity" },
    { value: "Redemption", label: "Redemption" },
    { value: "Reward", label: "Reward" },
    { value: "Virtual_Event", label: "Virtual Event" },
  ],
  PROGRAM_CATEGORY_OPTIONS: [
    { value: "Virtual_Event", label: "Virtual Event" },
    { value: "Webinar", label: "Webinar" },
    { value: "Physical_Event", label: "Physical Event" },
  ],
});

export default constants;
